import {UserRole} from "@data/schema/account/user-role";
import {UserPermission} from "@data/schema/account/user-permission";
import {Branch} from "@data/schema/account/branch";


export class AppUser{
   userId: string;
   clientId: string;
   userName: string;
   email: string;
   mobile : string;
   firstName: string;
   lastName: string;
   middleName: string;
   roleList: UserRole[] = [];
   permissionList: UserPermission[] =[];
   borrower : boolean;
  lastUpdatedAt: Date
  lastUpdatedBy: string;
  deleteFlag: boolean;
  exist : boolean;
  borrowerInvitationEmailSentFlag : boolean;
  borrowerInvitationEmailAlreadySentFlag : boolean;
  nonBorrowerInvitationEmailSentFlag : boolean;
  nonBorrowerInvitationEmailAlreadySentFlag : boolean;
  assignedBranch : Branch;
  b2cUser : boolean;
  active : boolean;
}
